import React from "react";
import { Typography } from "@mui/material";
import Box from "@mui/material/Box";
import parse from "html-react-parser";
import ViewImages from "../viewImages/viewImages";
import "../common.scss";

// Rich-text fields are stored as HTML; render them the way the other
// incident report sections do rather than printing raw markup.
const renderHtml = (value) => {
  if (!value) return "";
  try {
    return parse(unescape(value));
  } catch (e) {
    return value;
  }
};

const PropertyDamageDetail = ({ additionalData }) => {
  const propertyDamage = additionalData?.propertyDamage;

  return (
    <div className="commonOveride">
      <Box className="commoninfoWrap">
        <Box className="commoninfoBox">
          <Box className="commoninfoleft">
            <Typography className="title">Property Damage Details:</Typography>

            <Box className="columns">
              <Typography className="listView">
                Project Name:
                <span className="font-w400">
                  {propertyDamage?.projectName}
                </span>
              </Typography>
              <Typography className="listView">
                Location of Damage:
                <span className="font-w400">
                  {propertyDamage?.locationOfDamage}
                </span>
              </Typography>
            </Box>

            <Box className="columns">
              <Typography className="listView">
                Whose property was damaged:
                <span className="font-w400">
                  {propertyDamage?.whosePropertyKeyValue?.value}
                </span>
              </Typography>
              <Typography className="listView">
                Type of Damage:
                <span className="font-w400">
                  {propertyDamage?.typeOfDamageKeyValue
                    ?.map((i) => i.value)
                    .join(", ")}
                </span>
              </Typography>
            </Box>

            <Typography className="listView">
              Describe the Damage:
              <span className="font-w400 blockView overRideTextEditor textNormal">
                {renderHtml(propertyDamage?.describeDamage)}
              </span>
            </Typography>

            <Box className="columns alignTop">
              <Typography className="listView">
                Contributing Factors:
                <span className="font-w400">
                  {propertyDamage?.contributingFactorsKeyValue
                    ?.map((i) => i.value)
                    .join(", ")}
                </span>
              </Typography>
              <Typography className="listView">
                Estimated Cost of Property Damage:
                <span className="font-w400">
                  {propertyDamage?.estimatedCost}
                </span>
              </Typography>
            </Box>

            <Typography className="listView">
              Actions Taken:
              <span className="font-w400 blockView overRideTextEditor textNormal">
                {renderHtml(propertyDamage?.actionsTaken)}
              </span>
            </Typography>

            <Typography className="listView columns">
              <div className="columnsf">Was a police report filed:</div>
              {propertyDamage?.isPoliceReportFiled === true ? (
                <div className="columnsl yesbtn">Yes</div>
              ) : propertyDamage?.isPoliceReportFiled === false ? (
                <div className="columnsl nobtn">No</div>
              ) : (
                ""
              )}
            </Typography>

            {propertyDamage?.isPoliceReportFiled === true && (
              <Typography className="listView">
                Police Report Number:
                <span className="font-w400">
                  {propertyDamage?.policeReportNumber}
                </span>
              </Typography>
            )}

            <Box>
              <Typography className="listView desNone">Files:</Typography>
              {additionalData?.files && additionalData?.files.length > 0 ? (
                <ViewImages
                  image={additionalData.files.map((file) => file.value)}
                  imageSize={{ size: "small" }}
                  showName={false}
                />
              ) : null}
            </Box>
          </Box>
          <Box className="commoninfoRight"></Box>
        </Box>
      </Box>
    </div>
  );
};

export default PropertyDamageDetail;
